import c0 from './hello_controller';
export const definitions = [
	{identifier: 'hello', controllerConstructor: c0},
];
